import { getMetricsPublisherChainAsync } from '@amzn/aapn-front-end-metrics'

export const removeComparedPartnerInCartMetricHandler: (partnerId: string) => Promise<void> = (partnerId: string) => {
  return getMetricsPublisherChainAsync('ComparedPartnersOnCompareCart').then(p => {
    p.publishCounter('partnerComparisonCart.remove.click', 1).publishString('partnerComparisonCart.remove.partnerId', partnerId)
  })
}

export const clearAllComparedPartnersInCartMetricHandler: () => Promise<void> = () => {
  return getMetricsPublisherChainAsync('ComparedPartnersOnCompareCart').then(p => {
    p.publishCounter('partnerComparisonCart.clearAll.click', 1)
  })
}

export const comparePartnersInCartMetricHandler: (comparedPartnerCount: number) => Promise<void> = (comparedPartnerCount: number) => {
  return getMetricsPublisherChainAsync('ComparedPartnersOnCompareCart').then(p => {
    p.publishCounter('partnerComparisonCart.comparePartnersButton.click', 1).publishString(
      'partnerComparisonCart.comparePartnersButton.partnerCount',
      `${comparedPartnerCount}`,
    )
  })
}

export const partnerSummaryCTAClickMetricHandler: (
  id: string,
  cardIndex: number,
  currentPageSize: number,
  currentPageNumber: number,
  clickMetricName: string,
  partnerIdMetricName: string,
  cardRankMetricName: string,
) => Promise<void> = (
  id: string,
  cardIndex: number,
  currentPageSize: number,
  currentPageNumber: number,
  clickMetricName: string,
  partnerIdMetricName: string,
  cardRankMetricName: string,
) => {
  const adjustedCardRank = currentPageNumber * currentPageSize + cardIndex + 1
  return getMetricsPublisherChainAsync('PartnerDirectory').then(p => {
    p.publishCounter(clickMetricName, 1)
      .publishString(partnerIdMetricName, id)
      .publishString(cardRankMetricName, adjustedCardRank.toString())
  })
}

export const comparedPartnersMetricOnUrlParamsHandler: (partnerId: string, methodName: string, metricName: string) => Promise<void> = (
  partnerId: string,
  methodName: string,
  metricName: string,
) =>
  getMetricsPublisherChainAsync(methodName).then(p => {
    p.publishString(metricName, partnerId)
  })

export const navigateSliderMetricHandler: (methodName: string, metricName: string) => Promise<void> = (methodName: string, metricName: string) =>
  getMetricsPublisherChainAsync(methodName).then(p => {
    p.publishCounter(metricName, 1)
  })

export const viewPartnerOnMobileMetricHandler: (methodName: string, metricName: string, partnerId: string) => Promise<void> = (
  methodName: string,
  metricName: string,
  partnerId: string,
) =>
  getMetricsPublisherChainAsync(methodName).then(p => {
    p.publishString(metricName, partnerId)
  })

export const clickPartnerComparisonDetailsMetricHandler: (metricName: string) => Promise<void> = (metricName: string) =>
  getMetricsPublisherChainAsync('PartnerComparisonDetails').then(p => {
    p.publishCounter(metricName, 1)
  })

export const clickPartnerComparisonCardMetricHandler: (partnerId: string, clickMetricName: string, stringMetricName: string) => Promise<void> = (
  partnerId: string,
  clickMetricName: string,
  stringMetricName: string,
) =>
  getMetricsPublisherChainAsync('PartnerComparisonCard').then(p => {
    p.publishCounter(clickMetricName, 1).publishString(stringMetricName, partnerId)
  })
